import fetchPisto from "@/api/pistoAPI"

const getPistito = async () => {
    const res = await fetchPisto.get(`/random.php`)
    console.log(res)
    return res.data.drinks[0]
}


export default getPistito